import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressiveBar } from 'ustore-ui';

import { I18nPipe } from '../../pipes/i18n.pipe'
;
@Component({
  selector: 'umkt-inactivity-modal',
  standalone: true,
  imports: [CommonModule, ProgressiveBar, I18nPipe],
  template: `
    <div class="modal-overlay" *ngIf="isVisible">
      <div class="modal-container">
        <div class="modal-content">
          <div class="modal-header">
            <h2>{{ 'components.inactivityWarning.title' | i18n }}</h2>
          </div>
          
          <div class="modal-body">
            <p>{{ 'components.inactivityWarning.message' | i18n }}</p>
            
            <div class="countdown-section">
              <div class="time-display">
                <span class="time-number">{{ remainingSeconds }}</span>
                <span class="time-label">{{ 'components.inactivityWarning.secondsRemaining' | i18n }}</span>
              </div>
              
              <!-- Progress bar usando ustore-ui -->
              <ustore-progressive-bar 
                [currentValue]="60 - remainingSeconds" 
                [totalValue]="60"
                [barColor]="'#da291c'"
                [backgroundColor]="'#cee7e8'"
                [viewCurrentValue]="false"
                [size]="'medium'"
                [percentageDirection]="'center'">
              </ustore-progressive-bar>
            </div>
          </div>
          
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="onContinueSession()">
              {{ 'components.inactivityWarning.continueButton' | i18n }}
            </button>
            <button 
              type="button" 
              class="btn btn-secondary" 
              (click)="onLogoutNow()">
              {{ 'components.inactivityWarning.logoutButton' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./inactivity-modal.component.scss']
})
export class InactivityModalComponent {
  @Input() isVisible = false;
  @Input() remainingSeconds = 60;
  
  @Output() continueSession = new EventEmitter<void>();
  @Output() logoutNow = new EventEmitter<void>();

  onContinueSession(): void {
    this.continueSession.emit();
  }

  onLogoutNow(): void {
    this.logoutNow.emit();
  }
}
